import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { Skeleton } from '@/components/ui/skeleton'
import { formatDateTime } from '@/lib/utils'
import { ContentStatusBadge, ConfidencePill } from './ContentStatusBadge'
import { CONTENT_TYPE_LABELS } from '../hooks/useContent'
import type { ContentItem } from '../api/contentApi'

interface ContentTableProps {
  items: ContentItem[]
  onView: (item: ContentItem) => void
  isLoading?: boolean
}

export function ContentTable({ items, onView, isLoading }: ContentTableProps) {
  if (isLoading) {
    return (
      <div className="space-y-2">
        {[...Array(6)].map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    )
  }
  if (!items.length) {
    return <p className="text-muted-foreground text-sm py-10 text-center">No content items match this view.</p>
  }
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Title</TableHead>
          <TableHead>Type</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Confidence</TableHead>
          <TableHead>Source</TableHead>
          <TableHead>Updated</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((item) => (
          <TableRow key={item.id} className="cursor-pointer" onClick={() => onView(item)}>
            <TableCell className="font-medium">
              {item.title}
              {item.targetRef && <div className="text-xs text-muted-foreground">{item.targetRef}</div>}
            </TableCell>
            <TableCell>{item.contentType === 'blog_editorial' && item.payload.publicationDestination === 'academy' ? 'Academy' : CONTENT_TYPE_LABELS[item.contentType] || item.contentType}</TableCell>
            <TableCell><ContentStatusBadge status={item.status} /></TableCell>
            <TableCell><ConfidencePill value={item.confidence} /></TableCell>
            <TableCell className="text-xs capitalize">{item.source}</TableCell>
            <TableCell className="text-xs text-muted-foreground">{formatDateTime(item.updatedAt)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
